import React, { Fragment } from 'react';
import {
  Badge, Box, Separator, Text,
} from '@usealloy/component-library';
import { Link, ScrollableStyledBox } from '~/entities/evaluations/watchlist-review/styles';
import { MatchDetailCard } from '../MatchDetailCard';
import type { MatchData } from '../../../types';
import { MatchDatum } from '../MatchDatum';


const UnsupportedMatchDetailSummary = ({
  match,
}: {
  match: MatchData;
}) => (
  <ScrollableStyledBox data-watchlist-container="scroller" data-testid="unsupportedMatchDetailSummary">
    <MatchDetailCard
      header={(
        <Box
          style={{
            border: 'none',
            borderRadius: 'var(--cl-radius-3)',
          }}
          wrap="wrap"
          justifyContent="space-between"
          data-dd-action-name="alloydd-watchlistDetail-sectionToggle"
        >
          <Badge style={{ background: 'none', padding: 0 }} outline={false}>
            <Box id="match-details-label" gap={2} justifyContent="flex-start">
              <Text
                lineHeight={4}
                size={3}
                weight={700}
              >
                Details
              </Text>
            </Box>

          </Badge>
        </Box>
  )}
    >
      <Box direction="column" gap={4}>
        {match.listings.map(({ details, media }, i) => (
          <Fragment key="only-key">
            {!!i && <Separator style={{ marginBlock: 'var(--cl-space-4)' }} />}
            {details.map(detail => (
              <MatchDatum
                key={detail.label}
                label={detail.label}
              >{detail.values.join(', ')}
              </MatchDatum>
            ))}

            {media?.map((medium, j) => (
              <Fragment key={medium.url}>
                {!!j && <Separator style={{ marginBlock: 'var(--cl-space-4)' }} />}
                <MatchDatum label="URL">
                  <Link
                    as="a"
                    color="var(--cl-juicy-blue)"
                    href={medium.url}
                    rel="noopener noreferrer"
                    target="_blank"
                    data-dd-action-name="alloydd-watchlistDetail-url"
                  >
                    {medium.url}
                  </Link>
                </MatchDatum>
              </Fragment>
            ))}
          </Fragment>
        ))}
      </Box>
    </MatchDetailCard>
  </ScrollableStyledBox>
);

export default UnsupportedMatchDetailSummary;
